<div class="mb-3">
  <app-field-title [titleInfo]="inputContent" [formControlObj]="formControlObj">
    <button
      header
      type="button"
      class="btn btn-sm btn-link"
      (click)="toggleShowComment()"
    >
      {{ showComment ? 'Remove Comment' : 'Add Comment' }}
    </button>
    <div>
      <select
        class="form-select"
        [(ngModel)]="dataStringValue"
        name="selectWithTextModel"
        [required]="inputContent.isMandatory && !inputContent.isHidden"
        #selectWithTextModel="ngModel"
        [ngClass]="{
          'ng-touched': selectWithTextModel.touched,
          'ng-dirty': selectWithTextModel.dirty,
          'ng-invalid': selectWithTextModel.invalid,
          'ng-valid': selectWithTextModel.valid
        }"
        (ngModelChange)="selectOption()"
      >
        <option value="">
          {{ isOptionLoading ? 'Loading..' : 'Select Option' }}
        </option>
        <ng-container *ngFor="let group of optionGroupsFor(optionsObs | async)">
          <optgroup *ngIf="group.heading" [label]="group.heading">
            <option *ngFor="let option of group.options" [value]="option.key">
              {{ option.value }}
            </option>
          </optgroup>
          <ng-container *ngIf="!group.heading">
            <option *ngFor="let option of group.options" [value]="option.key">
              {{ option.value }}
            </option>
          </ng-container>
        </ng-container>
      </select>
      <div *ngIf="showComment">
        <textarea
          style="white-space: pre-line"
          #commentBox
          class="form-control mt-2"
          placeholder="Add comment"
          [(ngModel)]="dataStringExtraValue"
          (ngModelChange)="selectOption()"
        ></textarea>
      </div>
    </div>
  </app-field-title>
</div>
